// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alternative-language__select[data-v-149cf60e] {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
